"use client";

import { useEffect, useState } from "react";
import { authClient } from "@/lib/auth-client";
import { PencilSimple } from "@phosphor-icons/react";

type InlineEditOverlayProps = {
  contentId: string;
  editHref: string;
};

export function InlineEditOverlay({ contentId, editHref }: InlineEditOverlayProps) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    async function checkAdmin() {
      try {
        const { data: session } = await authClient.getSession();
        if (!session?.user?.email) {
          setChecked(true);
          return;
        }

        const res = await fetch("/api/admin/check-access");
        if (res.ok) {
          const data = await res.json();
          setIsAdmin(data.isAdmin === true);
        }
      } catch {
        // Not logged in or error — don't show overlay
      }
      setChecked(true);
    }

    checkAdmin();
  }, [contentId]);

  if (!checked || !isAdmin) return null;

  return (
    <a
      href={editHref}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-2.5 bg-[var(--color-primary)] text-white rounded-full shadow-lg hover:bg-[var(--color-secondary)] transition-colors text-sm font-medium"
      title="Edit this content in the admin panel"
    >
      <PencilSimple size={18} weight="fill" />
      Edit this page
    </a>
  );
}
